var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 12.2673C23.9997 5.63996 18.627 0.267334 11.9997 0.267334C9.65216 0.267334 7.46244 0.9421 5.61284 2.10722L8.24314 3.22477L4.69531 4.73218L8.24314 6.23954L4.69531 7.74685L8.24314 9.25412L4.69531 10.7612L8.24314 12.2682L4.69531 13.7755L8.24314 15.2827L4.69531 16.7898L8.24314 18.297L4.69531 19.8043L8.24314 21.3114L5.61402 22.4283C7.46338 23.5929 9.65263 24.2673 11.9997 24.2673C18.627 24.2673 23.9997 18.8947 23.9997 12.2673Z",
    fill: "#751A46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/QAR.ebc88f16e924fa2bc61abf1ccf6cd6d8.svg";